import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { localizeDate } from '@pec/aion-ui-i18next/helpers/localize';
import { Message } from '@pec/aion-ui-components/components/Message';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IInsuranceV2 } from 'interfaces/insurance';

type RouteParams = {
  organizationId: string;
};

type Props = {
  insuranceExpired: IInsuranceV2[];
};

export const InsuranceExpiredV2: React.FC<Props> = ({ insuranceExpired }) => {
  const { t } = useTranslation();
  const { organizationId } = useParams<RouteParams>();

  return (
    <Grid item xs={12}>
      <Message
        primaryText={t('subscriber:dashboard.insuranceExpired.title', 'Your Insurance has Expired')}
        variant="error"
      >
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          {insuranceExpired.map(({ organizationName, questionSectionId, earliestPolicyExpirationDateUtc }, i) => (
            <li key={i}>
              <Typography variant="body1">
                <a href={`/organizations/${organizationId}/questionnaire-v2/${questionSectionId}`}>
                  {t('subscriber:dashboard.insuranceExpired.expiredDate', {
                    organizationName,
                    date: localizeDate({ value: earliestPolicyExpirationDateUtc, timeZoneId: 'UTC' }, t),
                    defaultValue: '{{organizationName}} expired on {{date}}'
                  })}
                </a>
              </Typography>
            </li>
          ))}
        </ul>
        <Typography variant="subtitle1">
          {t(
            'subscriber:dashboard.insuranceExpired.subtitle',
            'Please follow the links above to upload new insurance documents.'
          )}
        </Typography>
      </Message>
    </Grid>
  );
};
